import React from 'react';


export default (props) => {
	return (
		<section className="testimonials">

			{/* <div className="quote">
				<img src="/images/new/misc/quotations.svg"/>
				<p>Partnering with blueshyft has allowed Ladbrokes to offer an industry first Cash-In deposit service to our clients, 
				Australia-wide. The blueshyft app has allowed Australian newsagencies and convenience stores to be the epicentre of this service 
				which provides us with an extensive footprint that spans the country. Additionally, being able to leverage 
				the physical space to advertise the Cash-In service has been fantastic for both this product and our brand.</p>
				<h4>Greg Platz</h4>
				<h5>General Manager @ Ladbrokes</h5>
			</div> */}

			{/* <div className="quote">
				<img src="/images/new/misc/quotations.svg" />
				<p>Working with the blueshyft team continues to be an outstanding experience as we explore new ways to 
				develop creative sales solutions via their technology platform, which ultimately streamlines our internal 
				processes, adds convenience and value for our customers, all the while bringing business to newsagencies.</p>
				<h4>Troy Graham</h4>
				<h5>GM Marketing, Consumer Sales @ News Corp</h5>
			</div> */}


			<div className="quote">
				<img src="/images/new/misc/quotations.svg"/>
				<p>Collaborating with the team at blueshyft has really enabled us to leverage a whole new channel. With Blueshyft and The Lottery Office both being proudly Australian-owned companies, it's great to have a like-minded partner who values supporting the local economy and community as much as we do.</p>
				<h4>Jaclyn Wood</h4>
				<h5>CEO @ The Lottery Office</h5>
			</div>

		
		</section>
	)
}


// WEBPACK FOOTER //
// ./client/components/Testimonials/index.js